import React from 'react';
import styles from "../../../IntegrationForm.module.css";
import {ValidationResult} from "../../../../../../../../../elements/validator/component/ValidationComponent";
import {
    MultipleEmailValidator,
    OptionalEmailValidator,
    SuperchatApiKeyValidator
} from "../../../../../../../../../elements/validator/Validator";
import {ValidatedInputField} from "../../../../../../../../../elements/validator/component/ValidatedInputField";
import {
    IntegrationFormSelectionProvider,
    IntegrationRequest,
    IntegrationRequestPartial
} from "../../../IntegrationForm";
import {ValidatedChipInputField} from "../../../../../../../../../elements/validator/component/ValidatedChipInputField";

interface Props<T> {
    getMessage: (s: any) => any;
    updateRequest: (update: IntegrationRequestPartial) => void;
    selectionProvider: IntegrationFormSelectionProvider;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const SuperchatFields = <T extends IntegrationRequest>({
                                                                  getMessage,
                                                                  updateRequest,
                                                                  selectionProvider,
                                                                  updateValidationStatus
                                                              }: Props<T>) => {
    return <div>
        <div className={styles.fieldsLine}>
            <ValidatedInputField<string, T>
                onChange={(v: string) => updateRequest({superchatApiKey: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'superchatApiKey'}
                selector={selectionProvider.superchatApiKey}
                validator={SuperchatApiKeyValidator}
                label={'API Key'}
                placeholder={"e.g., 04kd8e-3f2l-..."}
                getMessage={getMessage}
            />
            <ValidatedInputField<string, T>
                required={false}
                onChange={(v: string) => updateRequest({superchatAimeUserEmail: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'superchatAimeUserEmail'}
                selector={selectionProvider.superchatAimeUserEmail}
                validator={OptionalEmailValidator}
                label={'Aime User Email'}
                placeholder={"example@mail.com"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLine}>
            <ValidatedChipInputField<T>
                required={false}
                onChange={(v) => {
                    updateRequest({superchatHandoverUserEmailList: v})
                }
                }
                updateValidationStatus={updateValidationStatus}
                fieldName={'superchatHandoverUserEmailList'}
                selector={selectionProvider.superchatHandoverUserEmailList}
                validator={MultipleEmailValidator}
                label={'Handover User Emails'}
                placeholder={"example@mail.com"}
                getMessage={getMessage}
            />
        </div>
    </div>
}
